import { Button, Drawer } from "antd";
import close from "./../../../../assets/images/close.svg";
import { useState } from "react";
import { ReactComponent as RadioOn } from "../../../../assets/images/radio-on.svg";
import { ReactComponent as RadioOff } from "../../../../assets/images/radio-off.svg";
const SelectSpecialityDrawer = ({
  closeDrawer,
  specialities,
  handleSelectedOptions,
}: any) => {
  const [selectedSpeciality, setSelectedSpeciality] = useState<any>(null);

  const key = specialities?.[0]?.key;

  const title =
    key === "specialities"
      ? "Specialty"
      : key === "doctors"
      ? "Doctor"
      : key === "patient_list"
      ? "Patient"
      : "";

  return (
    <Drawer
      placement="bottom"
      onClose={closeDrawer}
      closeIcon={false}
      open={true}
      height="auto"
      className="rounded-t-2xl overflow-hidden max-w-[450px] mx-auto"
      push={false}
    >
      <div className="flex justify-between items-center">
        <div className="font-semibold text-lg">{"Select " + title}</div>
        <img src={close} alt="close" onClick={closeDrawer} />
      </div>
      <div
        className="text-base py-2 flex flex-col gap-2 my-3 overflow-y-auto"
        style={{ maxHeight: "300px" }}
      >
        {specialities?.map((speciality: any, index: number) => (
          <div
            key={index}
            className="flex justify-between items-center bg-white p-4 rounded-xl cursor-pointer"
            style={{ boxShadow: "0px 0px 12px 0px rgba(162, 56, 255, 0.08)" }}
            onClick={() => setSelectedSpeciality(index)}
          >
            <div>{speciality?.name}</div>
            {selectedSpeciality === index ? <RadioOn /> : <RadioOff />}
          </div>
        ))}
      </div>
      <Button
        className={`flex justify-center overflow-hidden gap-2 self-stretch px-14 py-2 text-white bg-indigo-600 whitespace-nowrap rounded-xl border border-indigo-600 border-solid w-full h-[50px] text-base font-medium`}
        aria-label={"Confirm"}
        disabled={selectedSpeciality === null}
        onClick={() => {
          handleSelectedOptions(
            specialities[selectedSpeciality]?.name,
            specialities[selectedSpeciality]?.key
          );
          closeDrawer();
        }}
      >
        Confirm
      </Button>
    </Drawer>
  );
};

export default SelectSpecialityDrawer;
